<template>
  <!-- 特殊兑换码:链接类型的兑换码 -->
  <div>
    <div id="loginbox">
      <img src="@/assets/img/Special/rechargePost.png" />

      <van-form class="lform" ref="form" @submit="submit">
        <van-field
          class="lform-input key"
          placeholder="兑换码"
          v-model="form.redeCodeNo"
          disabled
          :rules="[
            {
              required: true,
              message: '请输入兑换码'
            }
          ]"
        />
        <van-field
          class="lform-input phone"
          placeholder="输入兑换码后自动显示"
          v-model="form.phone"
          name="phone"
          disabled
          :rules="[
            {
              required: true,
              validator: val => /^1[3|4|5|6|7|8|9][0-9]{9}$/.test(val),
              message: '请填写正确的手机号'
            }
          ]"
        />
        <van-field
          class="lform-input yzm"
          placeholder="请输入验证码"
          v-model="form.code"
          :rules="[
            {
              required: true,
              message: '请输入验证码'
            }
          ]"
        >
          <template #button>
            <div class="cdown" v-if="!time" @click="srlForSendVerifyCode">
              获取验证码
            </div>
            <van-count-down
              class="cdown"
              v-else
              :time="time"
              @finish="time = 0"
            />
          </template>
        </van-field>
        <van-button
          class="submit"
          :loading="loading"
          loading-text="兑换中..."
          native-type="submit"
        >
          去兑换
        </van-button>
      </van-form>
      <div class="lform explain">
        <div class="tips">兑换说明</div>
        <div>
          1、兑换码过期无法使用，请在有效期内充值。<br />
          2、充值手机号默认与发放时的手机号码一致且不支持修改。<br />
          3、充值可能存在延迟，若30分钟未到账，请重新兑换或联系客服。客服电话：
          <a href="tel:4006627299">4006627299</a>。
        </div>
      </div>
    </div>
    <div class="overlay" v-show="showDialog">
      <div class="center">
        <img src="@/assets/img/Special/warm.png" />
        <h1>温馨提示</h1>
        <div>
          该兑换码已兑换，若需要查看已兑换的券码，请输入
          <span>首次兑换时的手机号码</span>
        </div>
        <button @click="showDialog = false">好的</button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  srlForVerify,
  srlForSendVerifyCode,
  getRedeemCodeForSpecial
} from '@/api/srl.js'
export default {
  data() {
    return {
      time: 0,
      loading: false,
      showDialog: false,
      form: {
        redeCodeNo: undefined,
        phone: undefined,
        code: null
      }
    }
  },
  mounted() {
    this.getPhone()
  },
  methods: {
    async getPhone() {
      const paramsCode = this.$route.query?.code
      if (paramsCode) {
        this.form.redeCodeNo = paramsCode
      } else {
        this.$toast({
          message: '请携带兑换码！'
        })
        return
      }
      const { data, code, message } = await getRedeemCodeForSpecial({
        redeCodeNo: this.form.redeCodeNo
      })
      this.form.phone = data?.sendPhone || undefined
      if (code === 0) return
      this.$toast({
        message: message
      })
    },
    async submit() {
      try {
        this.loading = true
        const { message } = await srlForVerify({
          ...this.form,
          pageTypeMatchFlag: true, // 是否开启页面匹配，true-是
          redeemCodePageType: 5 // 兑换码页面类型，默认传 5
        })
        this.loading = false
        this.$toast({
          message: message
        })
      } catch (error) {
        this.loading = false
      }
    },
    srlForSendVerifyCode() {
      this.$refs.form.validate('phone').then(async () => {
        const { code, message } = await srlForSendVerifyCode({
          redeCodeNo: this.form.redeCodeNo,
          isRecharge: true,
          redeCodeType: 6 // 兑换码类型，默认传6
        })
        if (code === 0) {
          this.time = 60000
        } else {
          this.$toast.fail({
            message: message
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/style/Special.less';
</style>
